import React from "react";

const LayoutBody5 = ({ children }) => {
  const isStringContent = typeof children === 'string';

  return (
    <div className="layout-body layout-body-5">
      <div className="container">
        <div className="row layout-content">
          <div className="col-xs-12">
            {isStringContent ? (
              <div dangerouslySetInnerHTML={{ __html: children }} />
            ) : (
              <div>{children}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LayoutBody5;
